import type { CodeProps, CodeTheme } from "@emkit/builder-widgets";
import { useEditor } from "../../store.js";
import { CheckboxField, NumberField, SelectField, TextField } from "./fields.js";
import type { WidgetInspectorProps } from "./registry.js";

const THEME = ["light", "dark"] as const;

export function CodeInspector({ widget }: WidgetInspectorProps) {
  const update = useEditor((s) => s.updateWidgetProps);
  const p = widget.props as CodeProps;

  return (
    <>
      <TextField
        label="Title (filename)"
        value={p.title ?? ""}
        onChange={(v) => update(widget.id, { title: v || undefined })}
      />
      <TextField
        label="Language"
        value={p.language ?? ""}
        onChange={(v) => update(widget.id, { language: v || undefined })}
      />
      <TextField
        label="Code"
        value={p.code}
        multiline
        onChange={(v) => update(widget.id, { code: v })}
      />
      <SelectField
        label="Theme"
        value={p.theme ?? "dark"}
        options={THEME}
        onChange={(v) => update(widget.id, { theme: v as CodeTheme })}
      />
      <CheckboxField
        label="Show line numbers"
        value={p.showLineNumbers ?? true}
        onChange={(v) => update(widget.id, { showLineNumbers: v })}
      />
      <NumberField
        label="Radius (px)"
        value={p.radius ?? 8}
        min={0}
        max={32}
        onChange={(v) => update(widget.id, { radius: v })}
      />
    </>
  );
}
